module.exports = __webpack_public_path__ + "static/img/icon_back_to_top.3d90bded.svg";